import { event } from '@uhg-abyss/web/tools/event';
import { logger } from '@uhg-abyss/web/tools/logger';
import { createScript } from '@uhg-abyss/web/tools/script';
import { uniqueId } from '@uhg-abyss/web/tools/uniqueId';
import { config } from '@uhg-abyss/web/tools/config';

export const asyncMessaging = (options) => {
  if (options.enabled !== false) {
    const { hostname } = window.location;
    const generatedUniqueId = uniqueId();

    let scriptSrc = `${
      options.liveChatUrl || config('LIVE_CHAT_URL')
    }${generatedUniqueId}`;

    if (hostname === 'apps.uhcprovider.com') {
      scriptSrc = `${
        options.liveChatUrl || config('LIVE_CHAT_URL')
      }${generatedUniqueId}`;
    }

    createScript('async-msg-lp-chat-script', scriptSrc);
  }
  return {
    id: options.id,
    events: options.events,
    metadata: options.metadata,
    trigger: (tag) => {
      event.debounce(tag, 100, () => {
        if (options.logging) {
          logger.warn(`chat: ${tag.event}`, tag.data);
        }
        logger.log('Starting LivePerson Script, Tag info -', tag);
        // arg 1 : provider data, arg 2: userinfo url
        window.startLiveperson(tag.data, '/api/identity/ohid/userinfo');
      });
    },
  };
};
